import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { usePrescriptionFormColumn } from '../../hooks/use-prescription-form-column.js';
import PrescriptionFormColumn from './PrescriptionFormColumn.js';

const PrescriptionFormColumnContainer = ({ showHeading , side , parametersType ,  })=>{
    const { getLabel  } = useIntl();
    const isPhone = MediaQuery.useIsPhone();
    const prescriptionFormColumnData = usePrescriptionFormColumn({
        side,
        parametersType
    });
    const { isPupillaryDistanceFileOptional  } = useFeatureToggles();
    if (!prescriptionFormColumnData) return null;
    const { idExtension , prescriptionData , prescriptionValidationState , isSubmitted , opticalParameters ,  } = prescriptionFormColumnData;
    return /*#__PURE__*/ React.createElement(PrescriptionFormColumn, {
        className: `prescription-form__column-${side}`,
        id: `${side}-configurator-${idExtension}`,
        columnTitle: getLabel(`products.glasses.${side}Eye`),
        parameters: opticalParameters,
        selectedValues: prescriptionData,
        validations: prescriptionValidationState,
        showValidation: isSubmitted,
        onAttributeChange: prescriptionFormColumnData.handleChange,
        showHeading: showHeading,
        hideSelectLabels: side === 'left' && !isPhone,
        isPDParamOptional: isPupillaryDistanceFileOptional
    });
};

export { PrescriptionFormColumnContainer };
//# sourceMappingURL=PrescriptionFormColumnContainer.js.map
